import { PeopleInChatService } from './message/peopleInChat.service';
import { MessageService } from './message/message.service';
var peopleInChatService;
var messageService;
var init = function (employeeUrl, conversationUrl, accessToken) {
    peopleInChatService = new PeopleInChatService();
    messageService = new MessageService();
    peopleInChatService.setBaseUrl(employeeUrl);
    peopleInChatService.setAccessToken(accessToken);
    messageService.setBaseUrl(conversationUrl);
};
export { init, peopleInChatService, messageService };
